import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
    selector: 'calendar-footer-button',
    templateUrl: './calendar-footer-button.component.html',
    styles: [],
})
export class CalendarFooterButtonComponent implements OnInit {
    @Input() comp;
    date: Date = new Date();
    dateMeta = {
        day: this.date.getDate(),
        month: this.date.getMonth(),
        year: this.date.getFullYear(),
        otherMonth: false,
        today: true,
        selectable: true,
    };
    dateMetaMax = {
        day: 31,
        month: 11,
        year: 9999,
        otherMonth: false,
        today: true,
        selectable: true,
    };

    constructor(private elRef: ElementRef) {

    }

    ngOnInit() {

    }
}
